module.exports = __webpack_public_path__ + "static/media/baseball-ball.99874f56.svg";